import { Variants } from "framer-motion";

// Animation durations
export const DURATIONS = {
  fast: 0.2,
  normal: 0.3,
  slow: 0.5,
};

// Animation variants for commonly used components
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: DURATIONS.normal } },
};

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: DURATIONS.normal,
      ease: "easeOut",
    },
  },
};

export const slideInRight: Variants = {
  hidden: { x: "100%" },
  visible: {
    x: 0,
    transition: {
      duration: DURATIONS.normal,
      ease: "easeOut",
    },
  },
};

export const slideInLeft: Variants = {
  hidden: { x: "-100%" },
  visible: {
    x: 0,
    transition: {
      duration: DURATIONS.normal,
      ease: "easeOut",
    },
  },
};

export const popIn: Variants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: DURATIONS.normal,
      type: "spring",
      stiffness: 300,
      damping: 25,
    },
  },
};

// Staggered children animation
export const staggerContainer: Variants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

// For hover animations on buttons/cards
export const hoverScale = {
  scale: 1.02,
  transition: { duration: 0.2 },
};

export const pressScale = {
  scale: 0.98,
  transition: { duration: 0.1 },
};

// Check for reduced motion preference
export const shouldReduceMotion = () => {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
};

// Animation variants that respect reduced motion preference
export const getResponsiveVariants = (variants: Variants): Variants => {
  if (shouldReduceMotion()) {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.1 } },
    };
  }
  return variants;
};
